import { useState } from "react";

import styles from "../../_styles/InfoBlock.module.scss";
import ChooseInfoBlock from "../rightData/ChooseInfoBlock";
import { useGetVideoDetailsQuery } from "../../../../store/api/filmAPI";
import { useTranslation } from "react-i18next";
import useLikeClick from "../../../../hooks/useLikeClick";
import useFavouriteClick from "../../../../hooks/useFavouriteClick";
import { useDispatch } from "react-redux";
import { setShareModal } from "../../../../store/slices/modals.slice";
import { languageHandler, movieTitleHandler, posterPathHandler } from "../../../../utils/helpers";
import useShareClick from "../../../../hooks/useShareClick";
import MovieOverlay from "../section/MovieOverlay";
import {ROUTES} from "../../../../constants/routes";
import {useNavigate} from "react-router-dom";

interface IProps {
  currentItemId: number;
  clickHandler: () => void;
  inViewport: boolean;
  item: any;
}

const ChooseFooter = ({ currentItemId, clickHandler, inViewport, item }: IProps) => {
  const [showMovieTooltip, setShowMovieTooltip] = useState(false);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { likesList, likeHandler } = useLikeClick();
  const { favoritesList, favouritesHandler } = useFavouriteClick();
  const { shareList } = useShareClick();
  const navigate = useNavigate();

  const { data, isLoading } = useGetVideoDetailsQuery(
    {
      queries: { language: languageHandler(i18n.language) },
      id: currentItemId,
    },
    {
      skip: !inViewport,
    },
  );

  if (isLoading) {
    return <div />;
  }

  const shareHandler = () => {
    dispatch(setShareModal(true));
  };

  const title = movieTitleHandler(i18n.language, item);
  const posterPath = posterPathHandler(i18n.language, item);

  return (
    <div className={styles.footerContent}>
      {posterPath && (
        <div
          className={styles.footerPosterWrapper}
          onMouseEnter={() => setShowMovieTooltip(true)}
          onMouseLeave={() => setShowMovieTooltip(false)}
          onClick={() => {
            navigate(`${ROUTES.DETAILS}/${item?.id}`);
          }}
        >
          <img
            className={styles.footerPoster}
            src={`${process.env.REACT_APP_IMG_BASE_URL}${posterPath}`}
            alt={title}
            draggable={false}
          />
          <MovieOverlay item={item} visible={showMovieTooltip} />
        </div>
      )}
      <ChooseInfoBlock
        item={item}
        likeHandler={likeHandler}
        liked={likesList.data?.results.includes(data?.id)}
        shared={shareList.data?.results.includes(data?.id)}
        reviewHandler={clickHandler}
        favouritesHandler={favouritesHandler}
        shareHandler={shareHandler}
        inFavourites={favoritesList.data?.results.includes(data?.id)}
      />
      <button
        onClick={clickHandler}
        className={styles.footerContentButton}
      >
        {i18n.t('chat_search_movie')}
      </button>
    </div>
  );
};

export default ChooseFooter;
